import { type ComponentsOverrides } from '@mui/material/styles'
import { rem } from 'polished'

/*
 * Le divider Material ne doit plus être utilisé directement donc on lui met une couleur FLUO volontairement.
 * Il faut privilégier l'utilisation de designSystem/shapes/separator/Separator
 */
export const overridesDivider = (): ComponentsOverrides['MuiDivider'] => ({
  root: {
    borderColor: '#ADFF2F', // TODO: https://jira.vsct.fr/browse/SIBR-392
    height: rem(20),
  },
})
